module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.f093928d.ttf";